<dxp-multi-selector [selectorId]="this.componentId" data-source-key-name="description" [items]="this.paymentModesList"
    search-placeholder="{{msg.PlaceHolders.SelectOptions}}" placeholder="{{msg.PlaceHolders.SelectOptions}}"
    [label]="this.displayLabel" [optional]="this.isOptional" (selectedOptions)="setSelectedReceivingChannel($event)"
    multi-search="true" [maxLimit]="this.maxSelectionCount" [list-aria-label]="this.ariaText" [value]="this.defaultStatus?.description" #receivingChannelReference>
</dxp-multi-selector>
<span class="form-validation-error"
    *ngIf="!this.isOptional && this.submitted === 'enabled' && selectorControlName.errors && selectorControlName.errors['required']">
    {{msg.FormValidationMessage.receivingChannelRequired}}
</span>
